import React from 'react';

/**
 * Change against the previous period, or null when it cannot be expressed: a
 * missing side, or a prior of zero (0 to 5 is not "+500%").
 */
export function pctChange(
  current: number | null | undefined,
  prior: number | null | undefined,
): number | null {
  if (current === null || current === undefined || prior === null || prior === undefined || !prior) {
    return null;
  }
  return (100 * (current - prior)) / prior;
}

/** Movement against the previous period as a tinted chip. Renders nothing when there is no comparison. */
export function Delta({
  current,
  prior,
}: {
  current: number | null | undefined;
  prior: number | null | undefined;
}): React.ReactElement | null {
  const pct = pctChange(current, prior);
  if (pct === null) return null;
  const up = pct >= 0;
  return (
    <span
      title="vs the previous period of the same length"
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold tabular-nums ${
        up ? 'bg-emerald-500/10 text-emerald-400' : 'bg-rose-500/10 text-rose-400'
      }`}
    >
      {up ? '▲' : '▼'}
      {Math.abs(pct).toFixed(1)}%
    </span>
  );
}

export default Delta;
